import React, {useContext, useState} from 'react';
import Form from "react-bootstrap/Form";
import Icon from "@reacticons/bootstrap-icons";
import {Context} from "../../index";
import {useIntl} from "react-intl";
import {InputGroup} from "react-bootstrap";
import ContentRowInput from "./ContentRowInput";


const ContainerRowInput = (props) => {
    const {store} = useContext(Context);
    const intl = useIntl();
    const content = [{'value': 'E', 'name':intl.messages.empty},{'value': 'F', 'name':intl.messages.fullc}]
    const row = props.row;
    const timeslot = ['00:00','00:30', '01:00','01:30', '02:00','02:30', '03:00','03:30', '04:00','04:30', '05:00','05:30', '06:00','06:30', '07:00','07:30', '08:00','08:30',  '09:00','09:30',  '10:00','10:30',  '11:00', '11:30',  '12:00','12:30',  '13:00','13:30',  '14:00','14:30',  '15:00','15:30',  '16:00','16:30',  '17:00','17:30', '18:00','18:30', '19:00','19:30', '20:00','20:30', '21:00','21:30', '22:00','22:30', '23:00','23:30', 'Не согласованно'];
    const type_container = props.type_container;
    const type = store.type;
    const getReload = (element, id) => {
        if(element.id == id){
            return element.reload;
        }
    }

    console.log(row.contents.length)
    row.contents.map((r,_ir) => {
      console.log(r)
    })

    const handleChange = (e,name) => {
        let reload;

        if(name == 'type' && props.unload == 1){
            let type_value = e.target.value;
            type.filter((_type) => {
                if(_type.id == type_value ){
                    reload = _type.reload
                }
            })
            props.handleChange(reload,'reload', props.index);
        } else if(props.unload == 1){
            let type_value = row.type;
            type.filter((_type) => {
                if(_type.id == type_value ){
                    reload = _type.reload
                }
            })
            props.handleChange(reload,'reload', props.index);
        }
        props.handleChange(e.target.value,name, props.index);
    }

    const handleChangeContainer = (e) => {

        if(e.target.value.length > 0 && e.target.value < 11){
            e.target.setCustomValidity("incorect number");
        } else if(store.testContainer(e.target.value) === false){
            e.target.setCustomValidity("incorect number");
        } else {
            e.target.setCustomValidity("");
        }
        handleChange(e,'number')
    }

    const handleChangeChekbox = (e,name) => {
        let value = 0;
        if(row[name] === 0){
            value = 1;
            e.target.checked = true;
        } else {
            value = 0

            e.target.checked = false;
        }
        props.handleChange(value,name, props.index);
    }

    if(type_container > 0){
        row.type = type_container;
    }

    const addContent = (e) => {
        console.log("ok")
        props.addContent(props.index);
    }
    const handleChangeAdd = (e, name, index) => {
        props.handleChangeContent(e.target.value, name, props.index, index);
    }

    const deleteContent = (index) => {
        props.deleteAddContent(props.index,index)
    }



    if(props.full == 1){

       return (<>
           <tr>
               <td rowSpan={row.contents.length + 4}>
                   {props.index + 1}
               </td>

               <td>

                   {type_container > 0 ?

                       <Form.Select value={row.type} onChange={e => handleChange(e, 'type')} required disabled={(props.release.status > 1)?true:false}>
                           <option></option>
                           {type.map((s, i) =>
                               <option key={i} value={s.id}>{s.name}</option>
                           )}
                       </Form.Select>
                       :
                       <Form.Select value={row.type} onChange={e => handleChange(e, 'type')} required disabled={(props.release.status > 1)?true:false}>
                           <option></option>
                           {type.map((s, i) =>
                               <option key={i} value={s.id}>{s.name}</option>
                           )}
                       </Form.Select>

                   }
               </td>
               <td>{(props.unload > 0) ?
                   <Form.Select value={row.slot} onChange={e => handleChange(e, 'slot')} required disabled={(((row.slot != '00:00' || row.slot != '') && props.dayNow) || props.release.status > 1)?true:false} >
                       <option></option>
                       {timeslot.map((s, i) =>
                           <option key={i} value={s}>{s}</option>
                       )}
                   </Form.Select>
                       : null}
               </td>


               <td>
                   <Form.Control className="container_test" value={row.number} onChange={e => handleChangeContainer(e)}
                                 type="text" placeholder="" required={(props.unload == 3)?false:true} readOnly={(props.unload == 3)?true:false} disabled={(row.number != '' && props.dayNow && props.release.status > 1)?true:false}/>
               </td>
               <td>
                   <Form.Control type="text" required={(props.unload == 3)?true:false} value={row.car_number} onChange={e => handleChange(e, 'car_number')} disabled={(props.release.status > 2)?true:false}/>


               </td>
               <td>
                   <Form.Control disabled={(props.release.status > 2)?true:false} value={row.fio} onChange={e => handleChange(e, 'fio')} type="text" placeholder=""/>
               </td>
               <td rowSpan={row.contents.length + 4}>
                   {(props.release.status == 1)?
                       <a href="#" className="text-success" title="скопировать контейнер" onClick={(e) => props.copy(e,row)}>
                       <Icon name="back"></Icon>
                   </a> : null
                   }
                   {(props.release.status == 1  && !props.del) ? '' :
                       <a href="#" className="text-warning" onClick={(e) => props.delete(e, props.index)}>
                           <Icon name="trash"/>
                       </a>
                   }
               </td>
           </tr>
           <tr>


               <td colSpan="5" className="content-row">
                   <InputGroup>

                       <span className="input-group-text"> Наименование груза </span>
                       <Form.Control value={row.content_name}
                                     onChange={e => handleChange(e, 'content_name')}
                                     type="text" placeholder="" required
                                     disabled={(props.release.status > 1) ? true : false}/>
                       <span className="input-group-text">Артикул</span>
                       <Form.Control value={row.content_artikul}
                                     onChange={e => handleChange(e, 'content_artikul')}
                                     type="text" placeholder="" required
                                     disabled={(props.release.status > 1) ? true : false}/>
                       <span className="input-group-text"> Количество мест </span>
                       {(props.unload == 1) ?
                           <Form.Control value={row.content_count}
                                         onChange={e => handleChange(e, 'content_count')}
                                         type="number" placeholder="" required
                                         disabled={(props.release.status > 1) ? true : false}/> :
                           <Form.Control value={row.content_count}
                                         onChange={e => handleChange(e, 'content_count')}
                                         type="number" placeholder=""
                                         disabled={(props.release.status > 1) ? true : false}/>
                       }
                       <button type="button" className="input-group-text" onClick={e => addContent(e)}>+ Добавить груз</button>
                   </InputGroup>
               </td>
           </tr>

               {row.contents.map((r,_ir) =>
                   <ContentRowInput key={_ir}
                                      index={_ir}
                                      row={r}
                                      release={props.release}
                                      handleChangeAdd = {handleChangeAdd}
                                      deleteContent={deleteContent}


                   />

                       )
                }

           <tr>
               <td colSpan="5" className="prevAdd">
                   <InputGroup>
                       <span className="input-group-text">Пломба</span>
                       <Form.Control value={row.zpu}
                                     onChange={e => handleChange(e, 'zpu')}
                                     type="text" placeholder=""
                                     disabled={(props.release.status > 1) ? true : false}/>

                       <span className="input-group-text"> Масса груза </span>
                       <Form.Control value={row.content_weight}
                                     onChange={e => handleChange(e, 'content_weight')}
                                     type="text" placeholder="" disabled={(props.release.status > 1) ? true : false}/>
                       <span className="input-group-text">Инвойс</span>
                       <Form.Control value={row.invoice}
                                     onChange={e => handleChange(e, 'invoice')}
                                     type="text" placeholder="" disabled={(props.release.status > 1) ? true : false}/>

                       <span className="input-group-text">Ставка</span>
                       <Form.Control value={row.reload} onChange={e => handleChange(e, 'reload')}

                                     type="text" placeholder="" disabled={(props.release.status > 1) ? true : false}/>
                   </InputGroup>
               </td>

           </tr>
           <tr>


               <td colSpan="5">

                   <Form.Control as="textarea" placeholder="Комментарий к грузу и перегрузке"
                                 value={row.content_comment} onChange={(e) => handleChange(e, 'content_comment')}
                                 rows={2} disabled={(props.release.status > 1)?true:false}/>

               </td>

           </tr>
       </>)
    } else {
        return (
            <tr>
                <td>
                    {props.index + 1}
                </td>

                <td>
                    {type_container > 0 ?
                        <Form.Select value={type_container} onChange={e => handleChange(e, 'type')} required>
                            <option></option>
                            {type.map((s, i) =>
                                <option key={i} value={s.id}>{s.name}</option>
                            )}
                        </Form.Select> :
                        <Form.Select value={row.type} onChange={e => handleChange(e, 'type')} required>
                            <option></option>
                            {type.map((s, i) =>
                                <option key={i} value={s.id}>{s.name}</option>
                            )}
                        </Form.Select>

                    }
                </td>
                <td>
                    {row.type == 33 || row.type == 34 || type_container == 33 || type_container == 34 ?
                        <InputGroup className="mb-3">
                    <span className="input-group-text">
                    <Form.Check type="checkbox" value={row.connect}
                                onChange={(e) => handleChangeChekbox(e, 'connect')} placeholder=""/></span>

                        </InputGroup>
                        : null}
                </td>


                <td>
                    <Form.Control className="container_test" value={row.number} onChange={e => handleChangeContainer(e)}
                                  type="text" placeholder="" required/>
                </td>
                <td>
                    <Form.Control type="text" value={row.car_number} onChange={e => handleChange(e, 'car_number')}/>


                </td>
                <td>
                    <Form.Control value={row.fio} onChange={e => handleChange(e, 'fio')} type="text" placeholder=""/>
                </td>
                <td>
                    {!props.del ? '' :
                        <a href="#" className="text-warning" onClick={(e) => props.delete(e, props.index)}>
                            <Icon name="trash"/>
                        </a>
                    }
                </td>
            </tr>
        );
    }
}

export default ContainerRowInput;